import React from 'react';
import { StyledSkeleton } from './index.styles.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickDataProps } from '../../utils/pick-data-props.js';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
export const Skeleton = ({ width, height, aspectRatio, variant, className, margin, ...rest }) => {
    const getHeight = () => {
        if (aspectRatio) {
            return 'auto';
        }
        return height;
    };
    const baseProps = {
        className,
        margin,
        height: getHeight(),
        width,
        aspectRatio,
        variant,
        ...pickA11yProps(rest),
        ...pickDataProps(rest),
        'aria-hidden': true
    };
    return React.createElement(StyledSkeleton, { ...baseProps });
};
//# sourceMappingURL=index.js.map